import { Button, ButtonBorderRadius, ButtonTheme } from '@apply/components';

interface AddFilesButtonProps {
    id: string;
    onClick: () => void;
    disabled: boolean;
}

/** Opens the dialog to pick files to add. */
export const AddFilesButton = ({ id, onClick, disabled }: AddFilesButtonProps) => {
    return (
        <Button
            id={id}
            theme={ButtonTheme.Tertiary}
            borderRadius={ButtonBorderRadius.Small}
            disabled={disabled}
            handleClick={onClick}
            height='36px'
        >
            Add New File(s)
        </Button>
    );
};
